// import RepositoryFactory from "@/apis";
// const hcp = RepositoryFactory.hcp;
import hcp from "../../apis/hcp";

export default {
  addVolunteerHCP({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await hcp.addVolunteerHCP(payload);
        // console.log(data.data);
        // commit("ADD_VOLUNTEER", data.data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  emailBecomeVolunteer({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await hcp.emailBecomeVolunteer(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
